import Icon from '@/components/ui/AppIcon';

interface Step {
  id: number;
  label: string;
  completed: boolean;
}

interface StepIndicatorProps {
  currentStep: number;
  steps: Step[];
}

const StepIndicator = ({ currentStep, steps }: StepIndicatorProps) => {
  return (
    <div data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:16:4" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="16" data-component-end-line="87" data-component-file="StepIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20mb-8%22%7D" className="w-full mb-8">
      <div data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:17:6" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="17" data-component-end-line="63" data-component-file="StepIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20md%3Aflex%20items-center%20justify-between%22%7D" className="hidden md:flex items-center justify-between">
        {steps.map((step, index) => {
          const isActive = step.id === currentStep;
          const isCompleted = step.completed;

          return (
            <div data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:23:12" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="23" data-component-end-line="60" data-component-file="StepIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20flex-1%22%7D" key={step.id} className="flex items-center flex-1">
              <div data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:24:14" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="24" data-component-end-line="48" data-component-file="StepIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20flex-1%22%7D" className="flex flex-col items-center flex-1">
                <div data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:25:16" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="25" data-component-end-line="39" data-component-file="StepIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center
                    font-heading font-semibold text-sm transition-smooth
                    ${
                      isCompleted
                        ? 'bg-success text-success-foreground'
                        : isActive
                          ? 'bg-primary text-primary-foreground'
                          : 'bg-muted text-muted-foreground'
                    }
                  `}
                >
                  {isCompleted ? <Icon data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:38:33" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="38" data-component-end-line="38" data-component-file="StepIndicator.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22CheckIcon%22%7D" name="CheckIcon" size={20} /> : step.id}
                </div>
                <p data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:40:16" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="40" data-component-end-line="47" data-component-file="StepIndicator.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D"
                  className={`
                    mt-2 text-sm font-body font-medium text-center
                    ${isActive ? 'text-foreground' : 'text-muted-foreground'}
                  `}
                >
                  {step.label}
                </p>
              </div>

              {index < steps.length - 1 && (
                <div data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:51:16" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="51" data-component-end-line="58" data-component-file="StepIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20h-0.5%20mx-4%20mb-6%22%7D" className="flex-1 h-0.5 mx-4 mb-6">
                  <div data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:52:18" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="52" data-component-end-line="57" data-component-file="StepIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                    className={`
                      h-full transition-smooth
                      ${step.id < currentStep ? 'bg-success' : 'bg-muted'}
                    `}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:65:6" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="65" data-component-end-line="86" data-component-file="StepIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20md%3Ahidden%20items-center%20justify-center%20gap-2%22%7D" className="flex md:hidden items-center justify-center gap-2">
        {steps.map((step) => {
          const isActive = step.id === currentStep;
          const isCompleted = step.completed;

          return (
            <div data-component-id="src/app/customer-booking-flow/components/StepIndicator.tsx:71:12" data-component-path="src/app/customer-booking-flow/components/StepIndicator.tsx" data-component-line="71" data-component-end-line="83" data-component-file="StepIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              key={step.id}
              className={`
                transition-all duration-300 rounded-full
                ${
                  isCompleted
                    ? 'w-2 h-2 bg-success'
                    : isActive
                      ? 'w-8 h-2 bg-primary'
                      : 'w-2 h-2 bg-muted'
                }
              `}
            />
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
